import { useFieldState, RadioGroup as RadioGroup$1 } from 'informed';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import themes from '../../theming/themes.js';
import React from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _InputGroup from '../InputGroup/index.js';

var _excluded = ["children", "field", "label", "legendStyles", "hideLabel", "theme"],
  _excluded2 = ["notify"];
var RadioGroup = function RadioGroup(_ref) {
  var children = _ref.children,
    field = _ref.field,
    label = _ref.label,
    legendStyles = _ref.legendStyles,
    _ref$hideLabel = _ref.hideLabel,
    hideLabel = _ref$hideLabel === void 0 ? false : _ref$hideLabel,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  var fieldState = useFieldState(field);
  /* hack to get conflicting notify definitions
    between FieldProps and RadioGroup to not overlap and error out */
  var notify = rest.notify,
    theRest = _objectWithoutProperties(rest, _excluded2);
  return /*#__PURE__*/React.createElement(RadioGroup$1, _extends({
    field: field,
    notify: notify
  }, theRest), /*#__PURE__*/React.createElement(_InputGroup, {
    label: label,
    legendStyles: legendStyles,
    hideLabel: hideLabel,
    error: fieldState.error,
    theme: theme,
    field: field
  }, children));
};
var _RadioGroup = withDefaultTheme(RadioGroup);

export default _RadioGroup;
